const triggers = document.getElementsByClassName('collapsible');
for (const trigger of triggers) {
  trigger.addEventListener('click', () => {
    const target = trigger.getAttribute('data-target');
    const content = document.getElementById(target);
    if (content.style.maxHeight) {
      content.style.maxHeight = null;
    } else {
      content.style.maxHeight = content.scrollHeight + 'px';
    }
  });
}
